import React, { useEffect, useRef } from 'react';

export const AutoVideo = ({ src, poster, className, testid }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) el.play().catch(() => {});
      else el.pause();
    }, { threshold: 0.35 });
    io.observe(el);
    return () => io.disconnect();
  }, [src]);
  return (
    <video ref={ref} src={src} poster={poster} muted loop playsInline preload="metadata" className={className} data-testid={testid} />
  );
};
